import { CookieBannerOptions } from '@auto1-commons/cookie-gdpr'

export const removeDisabledStorage = async (
  consent: CookieBannerOptions[]
): Promise<void> => {
  const { default: helpers } = await import('cookieBanner/helpers')

  return helpers.removeDisabledStorage(consent)
}
